import type { User } from "@itaas/core/auth/models/user.model";

const ROLE_TO_PROFILE: Record<string, string> = {
  HOSPITOL_MANAGER: "direction",
  HOSPITOL_ADMIN: "direction",
  HOSPITOL_CLINICIAN: "medecin",
  HOSPITOL_PHARMACIST: "pharmacien",
  HOSPITOL_STAFF: "accueil",
  ISC_HOSPITOL_CLINICAL: "medecin",
  ISC_HOSPITOL_PHARMACY: "pharmacien",
};

export function resolveProfileIdFromUser(user: User | null | undefined): string {
  const slug = user?.roles?.[0]?.slug;
  if (slug && ROLE_TO_PROFILE[slug]) return ROLE_TO_PROFILE[slug];

  const local = user?.email?.split("@")[0] ?? "utilisateur";
  return local.replace(/[^a-z0-9-]/gi, "-").toLowerCase();
}

export function buildPageSlugFromLocation(pathname: string, search: string): string {
  const pathPart =
    pathname
      .replace(/^\/tenant\/hospitol\/?/, "")
      .replace(/[/:]/g, "-")
      .replace(/^-+|-+$/g, "") || "accueil";

  const queryPart = search
    ? search
        .replace(/^\?/, "")
        .replace(/[?&=]/g, "-")
        .replace(/^-+|-+$/g, "")
    : "";

  const combined = queryPart ? `${pathPart}__${queryPart}` : pathPart;
  return combined
    .toLowerCase()
    .replace(/[^a-z0-9-_]/g, "-")
    .replace(/-+/g, "-")
    .slice(0, 96);
}

export function resolveCaptureSelectorForPath(_pathname: string): string | undefined {
  return undefined;
}

export function buildCurrentPageFilename(profileId: string, pageSlug: string): string {
  return `${profileId}__${pageSlug}.png`;
}
